import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVIRONMENT } from '../../constants/env-constants';
import { createBearerBaseQuery } from '../../shared/rtk-bearer-base-query';

export const onboardingApi = createApi({
  reducerPath: 'onboarding-redux-query',
  baseQuery: createBearerBaseQuery(`${ENVIRONMENT.BACKEND_SERVER}/api/platform/companies`),
  endpoints: (build) => ({
    importUser: build.mutation({
      query: (data) => ({
        url: '/add-users',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useImportUserMutation } = onboardingApi;
